import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from 'componentsV2/Icon';
import Loader from 'components/Loader';

import Style from './SearchBar.module.scss';

const { search_inputPlaceholder: placeholderText } = window.Language;
const SearchBar = forwardRef(
  ({ isScrolled, theme = {}, onChange, onClear, value, fetching = false }, ref) => (
    <div
      className={classNames(
        Style.searchContainer,
        theme.searchContainer,
        isScrolled && Style.scrolled,
      )}
    >
      <div className={Style.inputContainer}>
        <Icon icon="search" />
        <input
          autoComplete="off"
          autoCorrect="off"
          autoFocus
          data-test="search-input"
          maxLength="50"
          onChange={onChange}
          placeholder={placeholderText}
          ref={ref}
          tabIndex="0"
          type="text"
          value={value}
        />
        {value && !fetching && (
          <div
            onClick={onClear}
            className={Style.clearIcon}
            role="button"
            aria-label="Clear search results"
            tabIndex="0"
          >
            <Icon icon="clear" />
          </div>
        )}
        {fetching && <Loader theme={Style} />}
      </div>
    </div>
  ),
);

SearchBar.propTypes = {
  isScrolled: PropTypes.bool,
  onChange: PropTypes.func,
  onClear: PropTypes.func,
  theme: PropTypes.shape({}),
  value: PropTypes.string,
  fetching: PropTypes.bool,
};

export default SearchBar;
